import JSZip from "jszip";
import { saveAs } from "file-saver";
import { Pack, PackAttachment } from "./Types";
import { rejects } from "assert";

export function uuid() {
  return Math.random().toString(36).substring(2, 15) +
    Math.random().toString(36).substring(2, 15);
}

export function getObjectAsJson(exportObj: any) {
  return JSON.stringify(exportObj, null, 2);
}

export function getObjectAsJsonFile(exportObj: any) {
  return (
    "data:text/json;charset=utf-8," +
    encodeURIComponent(getObjectAsJson(exportObj))
  );
}

export function downloadObjectAsJson(exportObj: any, exportName: string) {
  const dataStr = getObjectAsJsonFile(exportObj);
  var downloadAnchorNode = document.createElement("a");
  downloadAnchorNode.setAttribute("href", dataStr);
  downloadAnchorNode.setAttribute("download", exportName);
  document.body.appendChild(downloadAnchorNode); // required for firefox
  downloadAnchorNode.click();
  downloadAnchorNode.remove();
}

export function downloadPack(pack: Pack, attachments: PackAttachment[]) {
  if (attachments.length === 0) {
    downloadObjectAsJson({ pack }, `${pack.metadata.id}.json`);
    return;
  }

  const zip = new JSZip();

  zip.file(`pack.json`, getObjectAsJson({ pack }));

  const images = attachments.filter((x) => x.type.startsWith("image/"));
  const audio = attachments.filter((x) => x.type.startsWith("audio/"));
  const video = attachments.filter((x) => x.type.startsWith("video/"));

  if (images.length > 0) {
    const imageFolder = zip.folder("images");
    images.forEach((x) => {
      imageFolder!.file(x.name, x.data as any, { base64: true });
    });
  }

  if (audio.length > 0) {
    const audioFolder = zip.folder("audio");
    audio.forEach((x) => {
      audioFolder!.file(x.name, x.data as any, { base64: true });
    });
  }

  if (video.length > 0) {
    const videoFolder = zip.folder("video");
    video.forEach((x) => {
      videoFolder!.file(x.name, x.data as any, { base64: true });
    });
  }

  zip.generateAsync({ type: "blob" }).then(function (content) {
    saveAs(content, `${pack.metadata.id}.zip`);
  });
}

export async function getSerializedPack(
  pack: Pack,
  attachments: PackAttachment[],
  onProgressCallback: (progress: number) => void,
): Promise<Uint8Array> {
  const zip = new JSZip();

  zip.file(`pack.json`, getObjectAsJson({ pack }));

  const images = attachments.filter((x) => x.type.startsWith("image/"));
  const audio = attachments.filter((x) => x.type.startsWith("audio/"));
  const video = attachments.filter((x) => x.type.startsWith("video/"));

  const assets = images.length + audio.length;
  const doneAssets: any[] = [];

  if (images.length > 0) {
    const imageFolder = zip.folder("images");
    // images.forEach((x, index) => {
    //   imageFolder!.file(x.name, x.data as any, { base64: true });
    //   onProgressCallback(index / assets);
    // });
    await Promise.all(images.map(async (x) => {
      imageFolder!.file(x.name, x.data as any, { base64: true });
      doneAssets.push(".");
    }));
  }

  if (audio.length > 0) {
    const audioFolder = zip.folder("audio");
    // audio.forEach((x, index) => {
    //   audioFolder!.file(x.name, x.data as any, { base64: true });
    //   onProgressCallback((images.length + index) / assets);
    // });
    await Promise.all(audio.map(async (x) => {
      audioFolder!.file(x.name, x.data as any, { base64: true });
      doneAssets.push(".");
    }));
  }

  if (video.length > 0) {
    const videoFolder = zip.folder("video");

    await Promise.all(video.map(async (x) => {
      videoFolder!.file(x.name, x.data as any, { base64: true });
      doneAssets.push(".");
    }));
  }

  return new Promise((resolve, reject) => {
    zip.generateAsync({ type: "uint8array" }, (metadata) => {
      onProgressCallback(metadata.percent / 100);
    }).then(function (content) {
      // console.log(content);
      resolve(content);
    }).catch(
      () => {
        reject();
      },
    );
  });
}

export const getZipFromString = async (str: string) => {
  const zip = new JSZip();
  const file = zip.loadAsync(str, { base64: true });
  return file;
};

// merge even with overlapping keys
export const merge = (a: Object, b: Object) => {
  return Object.entries(b).reduce((o, [k, v]) => {
    o[k] = v && typeof v === "object"
      ? merge(o[k] = o[k] || (Array.isArray(v) ? [] : {}), v)
      : v;
    return o;
  }, a);
};
